<tr>
  <th *ngFor="let headerItem of headers">
    <div fxLayout="row" fxLayoutAlign="start center">
      {{ 'SHARED_COMPONENTS.TABLE.' + headerItem | translate }}
    </div>
  </th>
</tr>
